
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-age-filter",
      function () {
        return require("private-next-pages/ai-age-filter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-age-filter"])
      });
    }
  